import { gql } from "@apollo/client";

export const INACTIVE_INCIDENT_QUERY = gql`
  query INACTIVE_INCIDENT_QUERY(
    $oriIds: String!
    $perPage: Int
    $page: Int
    $originatorId: ID!
  ) {
    inactiveIncidents(
      oriIds: $oriIds
      perPage: $perPage
      page: $page
      originatorId: $originatorId
    ) {
      id
      incidentNumber
      classification {
        id
        name
      }
      officerIncidentSpecifics {
        id
        officer {
          id
          deptAttribute {
            id
            ori {
              id
              oriName
              abbreviation
            }
            badge
            assignment
            carNumber
            radioNumber
          }
        }
        clearedAt
      }
      commonCallType {
        id
        name
      }
      address {
        name
        validAddressAlerts {
          id
          alertType {
            id
            name
            alertLevel
          }
        }
      }
      callTime
      sealed
      locked
      personIncidentSpecifics {
        id
        sealed
        juvenile
        yoe
        person {
          id
          aliases {
            id
            target {
              id
              validPersonAlerts {
                id
                alertType {
                  id
                  name
                  alertLevel
                }
              }
            }
          }
          validPersonAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
          }
        }
      }
    }
  }
`;
